import { defaultFormValues } from '@gasbi/shared/web/forms/GasConsumingEquipmentForm';
import pick from 'lodash-es/pick';

import { useGetServiceOrganizationByIdQuery } from '@/features/serviceOrganizationsApi';

import { GasConsumingEquipmentFormValues } from '../types';

// TODO remove dependencies, add enums/reference books to api responses , need add reference books to the serviceOrganization
const useGetInitialValues = ({
  personalAccountId,
  gasConsumingEquipment,
  node,
}: any): GasConsumingEquipmentFormValues => {
  const { data: serviceOrganization } = useGetServiceOrganizationByIdQuery(
    gasConsumingEquipment?.serviceOrganizationId,
    { skip: !gasConsumingEquipment?.serviceOrganizationId },
  );

  if (gasConsumingEquipment) {
    return {
      ...pick(gasConsumingEquipment, [
        'id',
        'equipmentModel',
        'factoryNumber',
        'power',
        'amount',
        'efficiency',
        'hourlyCost',
        'heatingArea',
        'maintenanceEndDate',
        'isReserve',
        'equipmentGroupId',
      ]),
      meteringPointId: personalAccountId,
      gasMeteringNodes: node?.map(n => ({ id: n.id, name: n.value })) || [],
      equipmentGroup: {
        id: gasConsumingEquipment.equipmentGroupId,
        name: gasConsumingEquipment.equipmentGroupName,
      },
      equipmentGroupId: gasConsumingEquipment.equipmentGroupId,
      equipmentType: {
        type: '',
        id: gasConsumingEquipment.equipmentTypeId,
        value: gasConsumingEquipment.equipmentTypeName,
      },
      equipmentManufacturer: gasConsumingEquipment.equipmentManufacturerId
        ? {
            id: gasConsumingEquipment.equipmentManufacturerId,
            name: gasConsumingEquipment.equipmentManufacturerName,
          }
        : null,
      serviceOrganizationId: gasConsumingEquipment?.serviceOrganizationId,
      // @ts-expect-error
      serviceOrganization: gasConsumingEquipment?.serviceOrganizationId
        ? serviceOrganization
        : null,
    };
  }

  return {
    ...defaultFormValues,
    meteringPointId: personalAccountId,
    gasMeteringNodes: node?.map(n => ({ id: n.id, name: n.value })) || [],
  };
};

export default useGetInitialValues;
